import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MerchantService } from '../../../services/merchant.service';
import { AdminShellComponent } from '../../layout/admin-shell/admin-shell.component';

@Component({
    selector: 'app-add-edit-merchant',
    imports: [CommonModule, ReactiveFormsModule, AdminShellComponent],
    templateUrl: './add-edit-merchant.component.html',
    styleUrls: ['./add-edit-merchant.component.css']
})
export class AddEditMerchantComponent implements OnInit {
  merchantForm: FormGroup;
  isEdit: boolean = false;
  merchantId: string | null = null;
  // Presentation-only additions for this rebrand (no effect on the payload
  // sent to the API): a saving flag for the submit button's loading state,
  // and reveal toggles that only flip the <input type> of the two secret
  // fields between "password" and "text" — the stored/submitted values and
  // how they are fetched are unchanged. See PAIERLY_REBRANDING_REPORT.md.
  isSaving = false;
  revealStrictlySecret = false;
  revealStrictlyKey = false;
  // Presentation-only: shows the real host the app is running on (localhost,
  // dev, or prod) as the public-URL prefix instead of a hardcoded domain —
  // matches the real route (`/merchant/:paymentLink`).
  merchantUrlHost = `${location.host}/merchant/`;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private merchantService: MerchantService,
  ) {
    this.merchantForm = this.fb.group({
      name: ['', Validators.required],
      paymentLink: ['', Validators.required],
      strictlyPublic: [''],
      strictlySecret: [''],
      strictlyKey: [''],
      strictlyLogoUrl: [''],
      quickBookCompanyId: ['']
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
        this.merchantId = params.get('id');
        this.isEdit = !!this.merchantId;

        if (this.isEdit) {
          this.merchantService.getMerchant(this.merchantId!).subscribe(merchant => {
            console.log(merchant);
            this.merchantForm.patchValue({
              name: merchant.name,
              paymentLink: merchant.paymentLink,
              strictlyPublic: merchant.strictly ? merchant.strictly.user : '',
              strictlySecret: merchant.strictly ?  merchant.strictly.password : '',
              strictlyKey: merchant.strictly ? merchant.strictly.key : '',
              strictlyLogoUrl: merchant.strictly ? merchant.strictly.logoUrl : '',
              quickBookCompanyId: merchant.intuit.companyId
            });
          });
        }
      });
  }

  onSubmit() {
    if (this.merchantForm.invalid) {
      this.merchantForm.markAllAsTouched();
      return;
    }
    this.isSaving = true;
    const merchantData = {
      name: this.merchantForm.value.name,
      paymentLink: this.merchantForm.value.paymentLink,
      strictly: {
        user: this.merchantForm.value.strictlyPublic,
        password: this.merchantForm.value.strictlySecret,
        key: this.merchantForm.value.strictlyKey,
        logoUrl: this.merchantForm.value.strictlyLogoUrl
      },
      intuit: {
        companyId: this.merchantForm.value.quickBookCompanyId
      }
    };

    if (this.isEdit) {
        this.merchantService.updateMerchant(this.merchantId!, merchantData).subscribe(() => {
            this.router.navigate(['/list-merchant']);
          });
    } else {
        this.merchantService.addMerchant(merchantData).subscribe(() => {
            this.router.navigate(['/list-merchant']);
          });
    }
  }

  cancel() {
    this.router.navigate(['/list-merchant']);
  }
}
